module.exports = __webpack_public_path__ + "media/images/lb/894-ec758c5de2babb057ae0ab1e8471af1e.svg";